import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { format } from 'date-fns'

import { getFormerDay } from 'app/common/presentation/getFormerDay'
import { useUser } from 'app/user/application'

import { Button, PageBanner } from 'components'

import styles from './DashboardPage.module.scss'
import DashboardCard from './components/DashboardCard'
import DataInTeaser from './components/DataInTeaser'
import Delivery from './components/Delivery'
import LastActivity from './components/LastActivity'

const days = 30
const periodFormat = 'MMM dd, yyyy'
const today = new Date()
const daysBefore = getFormerDay(days)

const Dashboard = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('dashboard')
  const { workspace } = useUser()
  const workspaceName = workspace?.name ?? ''

  return (
    <div className={styles.dashboard}>
      <PageBanner
        subtitle={t('period', {
          daysBefore: format(daysBefore, periodFormat),
          today: format(today, periodFormat),
        })}
        title={t('title', { count: workspaceName ? 1 : 0, workspaceName })}
      >
        <Button variant="outlined" onClick={() => void navigate('/objectives/create')}>
          {t('actions.newObjective')}
        </Button>
        <Button variant="outlined" onClick={() => void navigate('/connections/browse')}>
          {t('actions.newConnection')}
        </Button>
        <Button onClick={() => void navigate('/signals/new')}>{t('actions.newSignal')}</Button>
      </PageBanner>
      <div className={styles.metricsSection}>
        <DataInTeaser />
        <Delivery />
      </div>
      <div className={styles.section}>
        <DashboardCard className={styles.activityCard} title={t('tiles.lastActivity.title')}>
          <LastActivity />
        </DashboardCard>
      </div>
    </div>
  )
}

export default Dashboard
